<template>
  <div class="login-view">
    <!-- Layer 0: Background Image -->
    <PageBackground 
      :imageUrl="heroImageUrl" 
      :position="heroPosition" 
    />
    
    <!-- Layer 0.5: Overlay for readability -->
    <OverlayGradient 
      :type="overlayType" 
      :opacity="overlayOpacity" 
    />
    
    <!-- Layer 1+: Content -->
    <div class="login-view__content">
      <LoginHeader 
        :clarityLogo="clarityLogoUrl"
      />
      <div class="login-view__main">
        <div class="login-view__main-left">
          <!-- Left half - empty for hero visual focus -->
        </div>
        <div class="login-view__main-right">
          <LoginForm />
        </div>
      </div>
      <LoginFooter 
        :integrityLogo="integrityLogoUrl"
        :companyText="companyText"
      />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import PageBackground from '@/components/Login/PageBackground.vue'
import OverlayGradient from '@/components/Login/OverlayGradient.vue'
import LoginHeader from '@/components/Login/LoginHeader.vue'
import LoginForm from '@/components/Login/LoginForm.vue'
import LoginFooter from '@/components/Login/LoginFooter.vue'

// Using require for Vue CLI compatibility
const clarityLogoUrl = ref(require('@/components/Login/assets/clarity-portal-logo.png'))
const integrityLogoUrl = ref(require('@/components/Login/assets/footer-logo.png'))

// Hero image configuration
const heroImageUrl = ref(require('@/components/Login/assets/hero-background.jpg'))
const heroPosition = ref('center')

// Overlay configuration
const overlayType = ref('gradient')
const overlayOpacity = ref(0.4)

// Footer text
const companyText = ref('Integrity Connect is a trading division of Integrity Communications Group')
</script>

<style scoped>
.login-view {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
}

.login-view__content {
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.login-view__main {
  flex: 1;
  display: flex;
  padding: 2rem;
}

.login-view__main-left {
  flex: 0 0 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-view__main-right {
  flex: 0 0 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 2rem;
}

@media (max-width: 768px) {
  .login-view__main {
    flex-direction: column;
    padding: 1.5rem 1rem;
  }

  .login-view__main-left {
    display: none;
  }

  .login-view__main-right {
    flex: 1;
    padding: 0;
  }
}
</style>